module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg19.65830631.jpg";